module.exports = __webpack_public_path__ + "static/media/control_entre_carga3.55468b48.svg";